import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useInactivityLogout from '../hooks/useInactivityLogout.hook';

/**
 * Shares the inactivity-warning state (from {@link useInactivityLogout}) with any component that
 * needs to coordinate with it. USWDS only supports one modal at a time, so the Support Mode expiry
 * warning must yield to this force-action inactivity warning rather than opening on top of it.
 */
export const InactivityWarningContext = createContext({
  isWarningOpen: false,
  continueSession: () => {},
});

export function InactivityWarningProvider({ children }) {
  const { isWarningOpen, continueSession } = useInactivityLogout();
  const value = useMemo(
    () => ({ isWarningOpen, continueSession }),
    [isWarningOpen, continueSession]
  );

  return (
    <InactivityWarningContext.Provider value={value}>
      {children}
    </InactivityWarningContext.Provider>
  );
}

InactivityWarningProvider.propTypes = {
  children: PropTypes.node,
};

InactivityWarningProvider.defaultProps = {
  children: null,
};
